export enum HTTP_HEADER {
  'X-CSRF-Token' = 'X-CSRF-Token',
  'X-Maintenance-Mode' = 'X-Maintenance-Mode',
}
